import React from 'react';
import {useServiceBase} from "../Components/ReactTable/useServiceBase";
import EditableReactTableV2 from "../Components/ReactTable/EditableReactTableV2";
import Page from "../Components/Page";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import {EditFormTextInputField} from "../Components/ReactTable/EditRecordForm";
import {Breadcrumbs} from "../Components/Breadcrumbs";

const FIPSService = () => {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/projections/`;
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl});

    const customColumns = [
        {header: "FIPS", accessorKey: "fips"},
        {header: "State FIPS", accessorKey: "state_fips"},
        {header: "County FIPS", accessorKey: "county_fips"},
        {header: "County", accessorKey: "county"},
        {header: "State", accessorKey: "state"},
        {header: "SPINS SNE Region", accessorKey: "spins_sne_region"},
        {header: "SPINS RIG Region", accessorKey: "spins_rig_region"},
        {header: "Census Region", accessorKey: "census_region"},
        {header: "Circana Region", accessorKey: "circana_region"},
        {header: "Circana Market", accessorKey: "circana_market"},
    ]


    return (<Page name={"FIPS Codes"}
                  breadCrumbs={<Breadcrumbs items={[{label: "Services"}, {label: "Projections"}, {label: "FIPS Codes"}]}/>}
            >
        <LoadingWrapper loading={loading}>
            <EditableReactTableV2
                filterable
                data={data.data}
                columns={customColumns}
                initialState={{ pagination: { pageSize: 25 }, sorting: [{ id: "fips", desc: false }] }}
                actionButtonsProps={{showAddButton: false}}
                editTable={[
                    {id: "fips", Component: args => <EditFormTextInputField {...args} isRequired  disabled />},
                    {id: "state_fips", Component: args => <EditFormTextInputField {...args} isRequired  disabled />},
                    {id: "county_fips", Component: args => <EditFormTextInputField {...args} isRequired disabled />},
                    {id: "state", Component: args => <EditFormTextInputField {...args} />},
                    {id: "county", Component: args => <EditFormTextInputField {...args} />},
                    {id: "spins_sne_region", Component: args => <EditFormTextInputField {...args} />},
                    {id: "spins_rig_region", Component: args => <EditFormTextInputField {...args} />},
                    {id: "circana_region", Component: args => <EditFormTextInputField {...args} />},
                    {id: "circana_market", Component: args => <EditFormTextInputField {...args} />},
                    {id: "census_region", Component: args => <EditFormTextInputField {...args} />},
                ]}
                onRowEditConfirmed={onRowEditConfirmed}
                onRowDeleteConfirmed={onRowDeleteConfirmed}
                editModalAdditionalClass={'fips-service-edit-modal'}
            />
        </LoadingWrapper>
    </Page>);
};

export default FIPSService;